angular.module("vgresiduos").controller("webhookEventCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `webhook-event`);
		};
	}
]);
